<template>
    <form class="messager-container" @submit.prevent="send">
        <div class="name-container">
            <img class="avatar" alt="Avatar icon" src="../assets/avatar.svg">
            <input
                type="text"
                v-model="name"
                required
                placeholder="Nickname"
                aria-label="Nickname"
            >
        </div>
        <textarea
            class="text"
            v-model="message"
            required
            aria-label="Enter Message"
            placeholder="Your Message…"
        />
        <div>
            <button type="button" @click="send" :disabled="canNotSend">Send</button>
        </div>
    </form>
</template>

<script>
import { computed, ref, getCurrentInstance } from 'vue';

import * as api from '../api.js';
import { encrypt } from '../message-crypt.js';

export default {
    props: {
        roomKey: {
            type: String,
            required: true,
        },
        password: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const { emit } = getCurrentInstance();

        const name = ref("");
        const message = ref("");
        const canNotSend = computed(() => !name.value || !message.value.trim() || !props.password );

        return {
            name,
            message,
            canNotSend,
            async send() {
                try {
                    await api.postMessage(props.roomKey, encrypt(
                            {
                                author: name.value,
                                message: message.value,
                            }, 
                            props.password,
                        ));
                }
                finally {
                    emit('message-posted');
                }
            },
        };
    },
    emits: [
        "message-posted",
    ],
};
</script>

<style scoped>
.messager-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    padding: 0.5em;
}

.name-container {
    display: flex;
    flex-direction: row;
}

.text {
    flex-grow: 1;
    margin-left: 1em;
    margin-right: 1em;
}

.avatar {
    width: 2em;
    height: 2em;
    margin-right: 0.1em;
}
</style>